import { Show, tokens } from '@welbe/web-design-system';
import { ReactNode } from 'react';
import { IoCheckmark } from 'react-icons/io5';
import { StyledButton } from './ToggleButton.styles';

type ToggleButtonProps = {
	isActive: boolean;
	children: ReactNode;
	onToggle: () => void;
};

export const ToggleButton = ({
	isActive,
	children,
	onToggle,
}: ToggleButtonProps): JSX.Element => {
	return (
		<StyledButton active={isActive} onClick={onToggle}>
			<Show when={isActive} fallback={null}>
				<IoCheckmark color={tokens.color_primary} />
			</Show>
			{children}
		</StyledButton>
	);
};
